import { CircleHelp } from 'lucide-react';

import { Heading } from '@/components/heading';
import { tv } from '@/utils/styles';

interface Props {
  title: string;
  children?: React.ReactNode;
  className?: string;
  isInteractive?: boolean;
}

const OptionSummaryCard = ({ title, children, isInteractive, className = '' }: Props) => {
  const { base, heading, card, infoIcon } = styles();
  return (
    <div className={base({ className, isInteractive })}>
      {isInteractive && <CircleHelp className={infoIcon()} />}
      <Heading as="h3" variant="h5" className={heading()}>
        {title}
      </Heading>
      <div className={card()}>{children}</div>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'relative rounded-lg border border-grey-200 p-4',
    heading: 'mb-3 font-medium',
    card: 'relative',
    cardHeading: 'mb-1',
    cardHeadingSmall: 'text-base',
    infoIcon: 'absolute right-4 top-4 size-4 text-grey-400',
  },
  variants: {
    isInteractive: {
      true: {
        base: 'cursor-pointer hover:border-grey-300 hover:shadow',
      },
    },
  },
});

export { OptionSummaryCard };
